<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Overview of the Month</h4>
                        <!--<vue-c3 :handler="handler" style="height:400px; width:100%;" class="m-t-20 conversation"></vue-c3>-->
                        <e-charts :auto-resize="true" :options="options" ref="linechart"></e-charts>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Demand Map (2018)</h4>
                        <h6 class="card-subtitle"></h6>
                        <world-population></world-population>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueC3 from 'vue-c3';
    import WorldPopulation from "./WorldPopulation";
    import "../../../assets/plugins/c3/c3.min.css";
    import ECharts from 'vue-echarts/components/ECharts';
    import 'echarts/lib/chart/line';
    import 'echarts/lib/component/legend';
    import 'echarts/lib/component/legendScroll';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';

    export default {
        name: "PriceDiscovery",
        components: {
            VueC3,
            WorldPopulation,
            ECharts
        },
        data() {
            return {
                handler: new Vue(),
                options: {
                    legend: {
                        type: 'scroll',
                        orient: 'horizontal'
                    },
                    tooltip: {
                        trigger: 'axis',
                        showContent: false
                    },
                    dataset: {
                        source: [
                            ['product', 'Jan', 'Feb', 'Mar', 'Apr'],
                            ['Wheat', 10, 10, 10, 12],
                            ['Corn', 7, 9, 8, 7]
                        ]
                    },
                    xAxis: {type: 'category'},
                    yAxis: {gridIndex: 0},
                    series: [
                        {type: 'line', smooth: true, seriesLayoutBy: 'row'},
                        {type: 'line', smooth: true, seriesLayoutBy: 'row'},
                        {type: 'line', smooth: true, seriesLayoutBy: 'row'}
                    ]
                }
            }
        },
        mounted() {
            this.handler.$emit('init', this.options)
        },
        ready: function() {
            window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy: function() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods: {
            handleResize() {
                this.handler.$emit('dispatch', (chart) => chart.resize())
            }
        }
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 400px;
    }
</style>
